import { render, staticRenderFns } from "./Navbaremail.vue?vue&type=template&id=4a4cbe91"
import script from "./Navbaremail.vue?vue&type=script&lang=js"
export * from "./Navbaremail.vue?vue&type=script&lang=js"
import style0 from "./Navbaremail.vue?vue&type=style&index=0&id=4a4cbe91&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports